import React, {useEffect, useCallback, useState} from "react";
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import lodash from 'lodash';
import './styles.scss';

import {getMasterTeams, getMasterYears} from '../../../../actions/metadata';
import {setCondition} from "../../../../actions/detail-search";
import TeamCondition from './TeamCondition';
import PlayerCondition from './PlayerCondition';
import CategorySection from './CategorySection';
import SelectPeriod from './SelectPeriod';
import TargetCondition from './TargetCondition';
import Analysis from './analysis-project';
import {TOTAL_DETAIL} from './constant';
import formErr from "./buildErrSearch";



function MainSearch() {
    const dispatch = useDispatch();
    const dataSearch = useSelector(state => state.detailSearch);
    const history = useHistory();
    const [formError, setFormError] = useState({});
    const [focusError, setFocusError] = useState(null)
    useEffect(() => {
        dispatch(getMasterYears());
        dispatch(getMasterTeams());
    }, []);

    const onChange = useCallback((values, field) => {
        dispatch(setCondition(values, field))
    },[]);
    const validateFormSearch = useCallback((field) => {
        const validate = formErr(dataSearch, field);
        if(!lodash.isEmpty(validate)) {
            setFormError(validate);
            let key;
            for (let k in validate) {
                key = k;
                break;
            }
            setFocusError(key);
        }
        else {
            setFormError({});
            history.push('/detailed-search/setup')
        }
    },[dataSearch]);

    return <div className="main-search">
        <div className='navigate-main-search'>
            <h2 style={{ minWidth: 'max-content'}}>詳細検索
                <span>
                    <i className="fa fa-question-circle"></i>
                    <div className='tooltips-detailed-search'><p>シーズンごとや月ごとの期間、対象選手やさまざまな項目の絞り込みを可能にする詳細検索機能です。あなたの独自アイデアを数字で表現できます。</p></div>
                </span>
            </h2>
            <div className="btn-send">
                <button className="btn-top-send-color" onClick={() => validateFormSearch(['teamIds','gameCateIds'])}>決定</button>
            </div>
            <div className="visible-btn">
                <div className='btn-title-search advance-search' style={{ display: "flex", overflow: 'hidden'}}>
                    <button className={`btn-advanced-search-pitcher ${dataSearch[TOTAL_DETAIL.TYPE]==='pitchers' && 'btn-pitcher-search'}`} onClick={() => onChange('pitchers', TOTAL_DETAIL.TYPE)}>投手成績</button>
                    <button className={`btn-advanced-search-batter ${dataSearch[TOTAL_DETAIL.TYPE]==='batters' && 'btn-batter-search'}`} onClick={() => onChange('batters', TOTAL_DETAIL.TYPE)}>打撃成績</button>
                </div>
            </div>
        </div>
        <div className='d-flex'>
            <div className='content-main-search'>
                <div className='all-btn-search'>
                    <div className='item-group-btn'>
                        <div className="navbar-topleft">
                            <h3 className='navbar-item' style={{ borderBottom: '1px solid #ddd',
                                marginBottom: 10,
                                paddingBottom: 10, width: '100%'}}>対象選択</h3>
                            <div className="visible-area">
                                <div className='btn-title-search advance-search' style={{ marginBottom: 20, marginTop: 15 }}>
                                    <button className={`btn-advanced-search-pitcher ${dataSearch[TOTAL_DETAIL.TYPE]==='pitchers' && 'btn-pitcher-search'}`} onClick={() => onChange('pitchers', TOTAL_DETAIL.TYPE)}>投手成績</button>
                                    <button className={`btn-advanced-search-batter ${dataSearch[TOTAL_DETAIL.TYPE]==='batters' && 'btn-batter-search'}`} onClick={() => onChange('batters', TOTAL_DETAIL.TYPE)}>打撃成績</button>
                                </div>
                            </div>
                        </div>

                        <div className='inner-item-group'>
                            <PlayerCondition focus={focusError} error={formError['teamIds']} selected={dataSearch[TOTAL_DETAIL.PLAYER_CONDITION]} onChange={(values) => onChange(values, TOTAL_DETAIL.PLAYER_CONDITION)}/>
                            <TeamCondition selected={dataSearch[TOTAL_DETAIL.TEAM_CONDITION]} onChange={(values) => onChange(values, TOTAL_DETAIL.TEAM_CONDITION)}/>
                        </div>
                    </div>
                    <CategorySection focus={focusError} error={formError['gameCateIds']} selected={dataSearch[TOTAL_DETAIL.CATEGORY_SECTION]} onChange={(values) => onChange(values, TOTAL_DETAIL.CATEGORY_SECTION)}/>
                    <SelectPeriod selected={dataSearch[TOTAL_DETAIL.SELECT_PERIOD]} onChange={(values, field) => onChange(values, field)}/>
                    <TargetCondition selected={dataSearch[TOTAL_DETAIL.TARGET_CONDITION]} onChange={(values) => onChange(values, TOTAL_DETAIL.TARGET_CONDITION)}/>
                </div>
            </div>
            <div className="analysis-wrap">
                <Analysis onChange={onChange}/>
            </div>
        </div>


        <div className='btn-send-search'>
            <button className='btn-send-color' onClick={() => validateFormSearch(['teamIds','gameCateIds'])}>決定</button>
        </div>
    </div>

}

export default MainSearch;
